import * as React from 'react';
import { connect } from 'react-redux';
import './CellphoneQuotation.css';
import { navigateTo } from '../../../../actions/navigationActions';
import { acceptQuote, setReplacementValue, checkReplacementValue, updateBlingReplacementValueToQuote, setIsOnQuoteScreen, addAcceptedBlingQuote, addToBlingNumbers } from '../../../../actions/salesActions';
import { showErrorModal } from '../../../../actions/modalActions';
import AcceptQuote from '../../AcceptQuote/AcceptQuote';
import NumberFormat from 'react-number-format';
import { isMobile, isDesktop } from 'react-device-detect';
import RequestCallBack from '../../PortablePossessions/RequestCallBack'

class CellphoneQuotation extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            loggedIn: this.props.auth.uid ? true : false,
            isInEdit: false,
            selectedExcessDropdown: false,
            showMore: false,
            startReplacementValue: this.props.sales.replacementValue,
            replacementValue: this.props.sales.replacementValue,
            excessValue: this.props.sales.portableItemDetails?.excess,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleAcceptQuote = this.handleAcceptQuote.bind(this);
        this.handleReplacementValue = this.handleReplacementValue.bind(this);
        this.handleUpdateRiskItem = this.handleUpdateRiskItem.bind(this);
    }

    async handleAcceptQuote(e: any) {
        this.props.dispatchSetIsOnQuoteScreen(false, "", "");
        this.props.dispatchAction(addToBlingNumbers())
        if (this.props.sales.isNewItem) {
            this.props.dispatchAcceptQuote()
        }
        else {
            await this.props.dispatchUpdateItemOnQuote()
            await this.setState({
                startReplacementValue: this.state.replacementValue
            })
        }
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    handleRedirect(nextPage: string) {
        this.props.redirectTo(nextPage);
    }

    async handleReplacementValue(e: any) {
        await this.setState({
            replacementValue: e.target.value.replace(this.props.profile.currencySymbol, "").replaceAll(",", "")
        });
        if (this.state.replacementValue.length > 0 && this.state.replacementValue.length !== '0') {
            await this.props.dispatchSetReplacementValue(Number(this.state.replacementValue));
            await this.props.dispatchCheckReplacementValue();
        }
    }

    async handleUpdateRiskItem(e: any) {
        await this.props.dispatchCheckReplacementValue();
        if (this.props.sales.replacementCheckResult === 'ok') {
            await this.props.dispatchUpdatePortablePossessionsToQuote();
            await this.setState({
                startReplacementValue: this.state.replacementValue
            })
        }
    }

    componentDidMount() {
        this.props.dispatchSetIsOnQuoteScreen(true, this.props.sales.portableItemDetails.riskItemId, this.props.sales.portablePossessionType);
    }

    public render() {
        const { isInEdit } = this.state;
        const blingType = this.props.sales.portableItemDetails?.quoteCovers[0]?.product?.name;
        const quoteItem = this.props.sales.portableItemDetails;

        return (
            <>
                <div className={this.props.auth.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-0 logged-out"}>
                    <div className="container pt-3 pt-lg-0 portable-container mobile-mt-20px">
                        <div className="row justify-content-center PortableQuoteDetails noma pt-0px">
                            <div className="col-lg-6 col-12 pb-lg-0 pt-lg-3 pt-0 pb-3 mr-lg-4 pt-0px">
                                <h3 className={"comp-portable-possessions mb-0px" + (isMobile ? " mt-20px" : " mt-10px")}>Cellphone cover</h3>
                                {this.props.sales.portablePossessionDescription.length > 100 &&
                                    <p className="portable-quote-description mt-5px mb-0px">{this.props.sales.portablePossessionDescription.substring(0, 100)}...</p>
                                }
                                {this.props.sales.portablePossessionDescription.length <= 100 &&
                                    <p className="portable-quote-description mt-5px mb-0px">{this.props.sales.portablePossessionDescription}</p>
                                }
                                <p className="line-height-normal font-weight-normal mb-5px mt-6px text-white">Phone no.</p>
                                <p className="font-weight-bold mb-0px line-height-normal text-white">{this.props.sales.riskItemPhonenumber}</p>
                            </div>
                            <div className="border-lg-right border-sm-bottom"></div>
                            <div className={"col-lg-4 col-md-6 col-12 pt-lg-0 nopa justify-content-center mx-auto" + (isMobile ? "" : " pt-3")}>
                                <p className={"comp-portable-possessions-monthly-premium mb-3px text-center" + (isMobile ? "" : " mt-20px")}>Monthly premium</p>
                                <p className="comp-portable-possessions-total mb-15px">{this.props.profile.currencySymbol} {quoteItem.quoteCovers[0].premium.toFixed(2)}</p> {/*Todo*/}
                                <div className="text-center">
                                    <button className="btn btn-solid-green w-100" onClick={this.handleAcceptQuote}>{this.props.sales.isNewItem ? "Add to quote" : "Update quote"}</button>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center noma">
                            <div className="col-12 nopa mb-60px" id="PortablePossessionsProductSummary">
                                <div className="Nutshell mt-18px mb-15px" id="PortableComprehensiveDetails">
                                    <div className="pt-3">
                                        <div className="mb-18px">
                                            <p className="productSummary-title mb-5px">Replacement value</p>
                                            <p className="font-size-12px font-weight-normal line-height-normal mb-20px">Tap on the text box to change your replacement value</p>
                                            <div className="row noma">
                                                <div className={"col-lg-8 col-12 nopa mr-15px mobile-mr-0px" + (isMobile ? " unset-max-width" : "")} id="replacementValue">
                                                    <NumberFormat className="replacement-input" id="ReplacementValueInputId" placeholder={this.props.profile.currencySymbol} name="replacementValue" thousandSeparator={true} thousandsGroupStyle="thousand" prefix={this.props.profile.currencySymbol} value={this.state.replacementValue} onChange={this.handleReplacementValue} />
                                                    {this.props.sales.replacementCheckResult !== "ok" && this.state.replacementValue !== "" &&
                                                        <p className="replacement-value-help-block mt-10px ml-20px mobile-ml-0px text-lg-left text-center mb-20px">The value can’t be {this.props.sales.replacementCheckResult} than {this.props.profile.currencySymbol}{this.props.sales.replacementCheckResult === 'more' ? this.props.sales.MaxReplacementValue?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(".00", "") : this.props.sales.MinReplacementValue?.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(".00", "")}</p>
                                                    }

                                                </div>
                                                <div className={"col-lg-4 col-12 nopa mobile-mt-20px" + (isMobile ? " unset-max-width " : " portable-quote-button-holder")}>
                                                    <button onClick={this.handleUpdateRiskItem} disabled={parseFloat(this.state.startReplacementValue) == parseFloat(this.state.replacementValue) || this.props.sales.replacementCheckResult !== "ok"} className={"btn " + ((this.state.startReplacementValue == this.state.replacementValue || this.props.sales.replacementCheckResult !== "ok") ? "btn-solid-green btn-portable-inactive" : "btn-solid-green")}>
                                                        Update value
                                                    </button>
                                                </div>
                                            </div>
                                            {this.props.sales.replacementCheckResult !== undefined && this.props.sales.replacementCheckResult !== "ok" && this.props.sales.replacementCheckResult !== "" && this.state.replacementValue !== "" && <div className={isMobile ? "mt-20px" : ""}> <RequestCallBack /> </div>}
                                        </div>
                                    </div>
                                </div>
                                <div className="Nutshell">
                                    <p className="productSummary-title mb-20px ">In a nutshell</p>

                                    {blingType == "Brand-new" &&
                                        <div className="row noma">
                                            <div className="col-12 nopa">
                                                <p className="mb-0px line-height-normal">Your cellphone is covered no matter where you are in the world. With the king’s cellphone cover you’ll get simple cheap insurance matched with our royal service.</p>
                                                <hr className="bling-quote-hr" />
                                            </div>
                                            <div className="col-12 nopa">
                                                <p className="bling-nutshell-titles">Worldwide cover for</p>
                                                <div className="row noma">
                                                    <div className="col-12 col-lg-4 nopa">
                                                        <div className="row noma">
                                                            <div className="mr-8px">
                                                                <div className="icon-checkmark-circle"></div>
                                                            </div>
                                                            <div className='col nopa mb-12px mt-3px'>
                                                                <p className="mb-0">Loss</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-lg-4 nopa">
                                                        <div className="row noma">
                                                            <div className="mr-8px">
                                                                <div className="icon-checkmark-circle"></div>
                                                            </div>
                                                            <div className='col nopa mb-12px mt-3px'>
                                                                <p className="mb-0">Theft</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-lg-4 nopa">
                                                        <div className="row noma">
                                                            <div className="mr-8px">
                                                                <div className="icon-checkmark-circle"></div>
                                                            </div>
                                                            <div className='col nopa mb-12px mt-3px'>
                                                                <p className="mb-0">Accidental damage</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 nopa">
                                                        <div className="row noma">
                                                            <div className="mr-8px">
                                                                <div className="icon-checkmark-circle"></div>
                                                            </div>
                                                            <div className='col nopa mb-12px mt-3px'>
                                                                <p className="mb-0">Water damage</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr className="bling-quote-hr" />
                                            </div>
                                            <div className="col-12 nopa">
                                                <p className="bling-nutshell-titles">Warranty</p>
                                                <p className="mb-0px font-weight-normal">Manufacturer’s warranty</p>
                                                <hr className="bling-quote-hr" />
                                            </div>
                                            <div className="col-12 nopa">
                                                <p className="bling-nutshell-titles">Excess</p>
                                            <p className="mb-0px font-weight-normal line-height-normal">5% of the claim value with a minimum of {this.props.profile.currencySymbol}1,250<br /><br />OR<br /><br /> 15% of the claim value with a maximum of {this.props.profile.currencySymbol}4,500</p>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="row justify-content-center mb-0px mt-20px">
                                    <div className="col-12">
                                        <p className="Overview-only-Pleas mb-0px">Overview only. Please refer to our <a target="_blank" href="Documents/King-price-insurance-policy.pdf">KPPD</a> and your policy schedule for more info.</p>
                                    </div>
                                </div>
                            </div>
                            {!isMobile &&
                                <div className="col-12 nopa mb-60px">
                                    <div className="text-center">
                                        <button className="btn btn-solid-green" id="AddToQuote" onClick={this.handleAcceptQuote}><span className="Add-to-quote">{this.props.sales.isNewItem ? "Add to quote" : "Update quote"}</span> <br /> <span className="QuoteTotal">{this.props.profile.currencySymbol} {quoteItem.quoteCovers[0].premium.toFixed(2)} pm</span></button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <AcceptQuote premuim={quoteItem.quoteCovers[0].premium.toFixed(2)} />
            </>
        )
    }
}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
        auth: state.auth
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchShowErrorModal: (error) => dispatch(showErrorModal(error)),
        dispatchAcceptQuote: () => dispatch(acceptQuote(false)),
        dispatchSetReplacementValue: (value) => dispatch(setReplacementValue(value)),
        dispatchCheckReplacementValue: () => dispatch(checkReplacementValue()),
        dispatchUpdatePortablePossessionsToQuote: () => dispatch(updateBlingReplacementValueToQuote()),
        dispatchSetIsOnQuoteScreen: (flag, itemId, itemDescription) => dispatch(setIsOnQuoteScreen(flag, itemId, itemDescription)),
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CellphoneQuotation);